<template>
<tr>
    <td>{{ utils.formatDate(aula.inicio) }}</td>
    <td>{{ utils.formatDate(aula.fim) }}</td>
    <td style="text-align: left">
        <template v-if="!editStatus">
            <span>{{ aula.status || "&lt;Sem status&gt;" }}</span>
            <button style="background-color: transparent; border: none" @click="editStatus = true"><i class="fa fa-edit"></i></button>
        </template>
        <template v-else>
            <input type="text" style="width: 15em" v-model="currentStatus">
            <button style="background-color: transparent; border: none" @click="setStatus(currentStatus)"><i class="fa fa-check"></i></button>
            <!-- <button style="background-color: transparent; border: none" @click="editStatus = false"><i class="fa fa-times"></i></button> -->
        </template>
    </td>
    <td>{{ aula.instrutor }}</td>
</tr>
    
</template>
<script>
import utils from '@/services/utils.js'
import urlApi from '@/router/urlApiV2'

export default {
    name: 'AulaAluno',
    props: {
        aula: Object,
        schema: String
    },
    data() {
        return {
            editStatus: false,
            currentStatus: this.aula.status,
            utils
        }
    },
    methods: {
        setStatus(status) {
            this.$http.post(urlApi + '/dashboard/aulas/praticas/atualizarStatusAula', { aulaId: this.aula.aulaId, schema: this.schema, status: status })
            .then(response => {
                if(response.data.success) {
                    this.$toasted.show('Status da aula atualizado', {
                        icon: 'fa-info',
                        position: 'top-right',
                        duration: 5000,
                        fullWidth: false
                    })
                    this.aula.status = this.currentStatus
                    this.editStatus = false
                }
            })
        }
    },
}
</script>